import { CT } from "../../../consts";

export const definitions = {
  title: "Branding",
  icon: "fingerprint",
  groups: [
    {
      label: "Header",
      options: [
        {
          title: "Show logo on the hosted page",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          applicable: "design",
          name: "brandShowLogo",
          defaultValue: 0,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Keep logo sticky",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          show: [
            {
              field: "brandShowLogo",
              value: 1,
              defaultValue: 0,
            },
          ],
          applicable: "design",
          name: "brandLogoSticky",
          defaultValue: 0,
          tooltip: {
            message: "Whether or not the branding should be visible on top of the hosted page."
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Hosted page logo size",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          show: [
            {
              field: "brandShowLogo",
              value: 1,
              defaultValue: 0,
            },
          ],
          style: {
            selector: [".dc-calendar-branding--header-image-container img"],
            property: "height",
          },
          applicable: "design",
          name: "brandLogoSize",
          defaultValue: "5em",
          tooltip: null,
          control: {
            kind: "cssDimension",
            options: {
              placeholder: "CSS value for image width",
            },
          
          },
        },
        {
          title: "Show back button on the hosted page",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          applicable: "design",
          name: "brandShowBackButton",
          defaultValue: 0,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Position of logo and back button",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          applicable: "design",
          name: "brandLogoPosition",
          defaultValue: "rev-logo-last",
          tooltip: null,
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: [
                {
                  label: "Back button on the left, logo on the right",
                  value: "rev-logo-last",
                },
                {
                  label: "Back button on the right, logo on the left",
                  value: "rev-logo-first",
                },
              ],
            },
          },
          show: [
            {
              field: "brandShowLogo",
              value: 1,
              defaultValue: 0,
            },
            {
              field: "brandShowBackButton",
              value: 1,
              defaultValue: 0,
              or: true,
            },
          ],
        },
        {
          title: "Back button label",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          applicable: "design",
          name: "brandBackButtonLabel",
          defaultValue: "← Back to home",
          show: [
            {
              field: "brandShowBackButton",
              value: 1,
              defaultValue: 0,
            },
          ],
          tooltip: null,
          control: {
            kind: "text",
            options: {},
          },
        },
        {
          title: "Back button URL",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          applicable: "design",
          name: "brandBackButtonURL",
          defaultValue: "",
          show: [
            {
              field: "brandShowBackButton",
              value: 1,
              defaultValue: 0,
            },
          ],
          tooltip: null,
          control: {
            kind: "text",
            options: {},
          },
        },
        {
          title: "Link color",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "brandingLinkColor",
          defaultValue: "#5e5e5e",
          show: [
            {
              field: "brandShowBackButton",
              value: 1,
              defaultValue: 0,
            },
          ],
          style: {
            selector: [".dc-calendar-branding--header-backbutton-container a"],
            property: "color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: true,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Link color on hover",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "brandingLinkColorHover",
          defaultValue: "#444444B2",
          show: [
            {
              field: "brandShowBackButton",
              value: 1,
              defaultValue: 0,
            },
          ],
          style: {
            selector: [
              ".dc-calendar-branding--header-backbutton-container a:hover",
            ],
            property: "color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: true,
              showTransparentOption: false,
            },
          },
        },
      ],
    },
  ],
};
